import { combineReducers } from 'redux';

import tabs from './tabReducers';

export default combineReducers({
  tabs,
});
